export const careersContent = [
  {
    heroTitle: "Ready For Your Dream Bathroom?",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "We're Expert Bathroom Renovators",
    introText: `
Whether you know what you're looking for or in need of inspiration, AquaHeat will guide you through the entire process from start to finish.`,
  },
  {
    contLeftTitle: "Full bathroom suite fit-outs",
    contLeftText: `Our new bathroom installations are completed to a high-standard and carried out by our highly-qualified bathroom installers `,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643104106/AquaHeat/new%20images/madrid_bathroom_suite_roomset_o0168b.webp`,
  },
  {
    contRightTitle: "Apprenticeships",
    contRightText: `Here at AquaHeat we are strong advocates for apprenticeships. We believe they are vital in tackling the UK’s skills shortages and youth unemployment rate. As a business, we have the opportunity to play an active fostering our own talent. `,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643630781/AquaHeat/new%20images/Screenshot_2022-01-31_at_12.03.49_aqrhfe.webp`,
  },
  {
    callToActionTitle: "For Bathrooms Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
